export const COLUMNS = ['Last Name', 'First Name', 'Email', 'Status'];

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const EMAIL = 'email';
export const STATUS = 'isActive';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/constants.js